import axios from "axios";
import { ErrorHandler } from "./error-handler";

const getCall = async (url, paramData='', token='', addOnHeader={}) => {
    let tokenHeader = {
        "X-Token": `${token}`,
        "Content-Type": "application/json",
        "Accept": "application/json",
    }

    let resp = await axios.get(url, {
        params: paramData,
        headers: Object.assign(tokenHeader, addOnHeader)
    })
    .then((res) => {
        return {status: true, context: {
            message: res,
            statusCode: 200
        }};
    })
    .catch((err) => {
        return ErrorHandler(err);
    })

    return resp;
}

const postCall = async (url, paramData='', token='', addOnHeader={}) => {
    const isFormData = typeof FormData !== 'undefined' && paramData instanceof FormData;
    let tokenHeader = {
        "X-Token": `${token}`,
        "Accept": "application/json",
    }
    if (!isFormData) {
        tokenHeader["Content-Type"] = "application/json";
    }

    let resp = await axios.post(url, paramData, {
        headers: Object.assign(tokenHeader, addOnHeader)
    })
    .then((res) => {
        return {status: true, context: {
            message: res,
            statusCode: 200
        }};
    })
    .catch((err) => {
        return ErrorHandler(err);
    })

    return resp;
}

const patchCall = async (url, paramData='', token='', addOnHeader={}) => {
    let tokenHeader = {
        "X-Token": `${token}`,
        "Content-Type": "application/json",
        "Accept": "application/json",
    }

    let resp = await axios.patch(url, paramData, {
        headers: Object.assign(tokenHeader, addOnHeader)
    })
    .then((res) => {
        return {status: true, context: {
            message: res,
            statusCode: 200
        }};
    })
    .catch((err) => {
        return ErrorHandler(err);
    })

    return resp;
}

const deleteCall = async (url, paramData='', token='', addOnHeader={}) => {
    let tokenHeader = {
        "X-Token": `${token}`,
        "Content-Type": "application/json",
        "Accept": "application/json",
    }

    let resp = await axios.delete(url, {
        params: paramData,
        headers: Object.assign(tokenHeader, addOnHeader)
    })
    .then((res) => {
        return {status: true, context: {
            message: res,
            statusCode: 200
        }};
    })
    .catch((err) => {
        return ErrorHandler(err);
    })

    return resp;
}

const downloadCall = async (url, token='', addOnHeader={}) => {
    let tokenHeader = {
        "X-Token": `${token}`,
        "Accept": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    }

    return axios.get(url, {
        responseType: 'blob',
        headers: Object.assign(tokenHeader, addOnHeader)
    });
}

export default {
    getCall, 
    postCall,
    patchCall,
    deleteCall,
    downloadCall
}